
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 367 367"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"stroke":"#D0EFEC","stroke-miterlimit":"10","stroke-width":"2","d":"M366.255 206.313v-45.817l-51.424-9.231c-3.652-13.199-8.535-25.698-15.797-37.582l29.683-43.164-32.273-32.256-43.25 30.346c-12.824-7.554-36.923-15.173-36.923-15.173L206.717.745h-45.84l-9.533 52.691c-13.207 3.65-25.415 7.937-36.626 14.791L71.617 38.645 39.28 68.906l29.364 46.135c-7.24 11.523-12.208 23.704-15.18 36.903l-52.72 9.232v46.134l52.401 9.528c3.588 13.263 8.387 25.232 15.415 36.819-.15.233-29.3 42.696-29.3 42.696l31.656 33.084L114.4 299.77c11.529 7.236 23.716 12.202 36.922 15.789l9.236 50.697h45.841l9.235-52.374c13.207-3.289 26.01-8.531 37.603-15.173l43.186 29.667 32.273-32.256-29.683-43.164c6.943-11.523 12.209-24.022 15.797-37.582zm-183.106 46.049c-37.92 0-68.664-30.728-68.664-68.629 0-37.9 30.744-68.607 68.664-68.607s68.665 30.728 68.665 68.607c0 37.88-30.744 68.629-68.665 68.629Z"}}),_c('path',{attrs:{"fill":"#fff","d":"M124.239 40.154a154.45 154.45 0 0 1 173.657 34.653l-53.975 51.648a79.74 79.74 0 0 0-89.663-17.892z"}}),_c('path',{attrs:{"fill":"#D1ED7E","d":"M182.5 303.5c66.826 0 121-54.173 121-121 0-66.826-54.174-121-121-121s-121 54.174-121 121c0 66.827 54.174 121 121 121"}}),_c('path',{attrs:{"fill":"#fff","d":"M240.095 322.417a153.92 153.92 0 0 1-201.62-82.036 153.9 153.9 0 0 1-10.895-78.925l22.903 2.869a130.837 130.837 0 0 0 180.646 136.823z"}}),_c('path',{attrs:{"stroke":"#94CC3F","stroke-dasharray":"12 12","d":"M41.742 198.026A142.502 142.502 0 0 1 196.91 41.632a142.5 142.5 0 0 1 76.558 31.359"}})]),_c('defs',[_c('clipPath',{staticClass:"i-a"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h367v367H0z"}})])])])
          )
        }
      }
    